import type { SheetData } from '@/domain/sheet';
import type { BusinessDate, CountEntry, Movement } from '@/domain/types';
import { rt } from './runtime';

function group<T extends { date: BusinessDate }>(rows: T[]): Map<BusinessDate, T[]> {
  const m = new Map<BusinessDate, T[]>();
  for (const r of rows) {
    const list = m.get(r.date);
    if (list) list.push(r);
    else m.set(r.date, [r]);
  }
  return m;
}

/** Everything the sheet arithmetic needs, for nights in [from, to] (or all of them). */
export async function loadSheetData(from?: BusinessDate, to?: BusinessDate): Promise<SheetData> {
  const db = rt().db;
  const inRange = (d: BusinessDate) => (!from || d >= from) && (!to || d <= to);
  const [items, nights, counts, moves] = await Promise.all([
    db.items.toArray(),
    db.nights.toArray(),
    from && to ? db.counts.where('date').between(from, to, true, true).toArray() : db.counts.toArray(),
    from && to ? db.moves.where('date').between(from, to, true, true).toArray() : db.moves.toArray(),
  ]);
  return {
    items,
    nights: new Map(nights.filter((n) => inRange(n.date)).map((n) => [n.date, n])),
    counts: group<CountEntry>(counts),
    moves: group<Movement>(moves.filter((m) => !m.voided)),
  };
}
